import { Input, InputGroup, InputRightElement, useDisclosure } from "@chakra-ui/react"
import type { FieldInputProps } from "formik"
import React from "react"
import { useTranslation } from "react-i18next"
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5"

interface PasswordInputProps {
  isDisabled: boolean
  isPasswordSetByUser: boolean
  showToggle: boolean
  field: FieldInputProps<string>
  onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void
}

const PasswordInput = ({
  isDisabled,
  isPasswordSetByUser,
  showToggle,
  field,
  onKeyPress,
}: PasswordInputProps): React.ReactElement => {
  const { t } = useTranslation()

  const {
    isOpen: isPasswordVisible,
    onToggle: onTogglePasswordVisible,
  } = useDisclosure({
    defaultIsOpen: false
  })

  return (
    <InputGroup size="md">
      <Input
        {...field}
        isDisabled={isDisabled}
        type={isPasswordVisible ? 'text' : 'password'}
        placeholder={
          isPasswordSetByUser ?
          t("enter_password", "Enter password") :
          t("set_password_first", "Set a password first")
        }
        onKeyPress={onKeyPress}
      />
      {showToggle && (
        <InputRightElement width="4.5rem">
          {isPasswordVisible ? (
            <IoEyeOutline onClick={onTogglePasswordVisible} />
          ) : (
            <IoEyeOffOutline onClick={onTogglePasswordVisible} />
          )}
        </InputRightElement>
      )}
    </InputGroup>
  )
}

export default PasswordInput
